/* NÖR v2 product page — gallery, variant picker, FAQ, cart, reveal */
(function () {
  'use strict';

  var root = document.querySelector('[data-n2-product]');
  if (!root) return;

  var variants = JSON.parse(root.querySelector('[data-n2-json]').textContent);
  var moneyFormat = root.dataset.n2Money || '${{amount}}';

  /* ---------- Gallery ---------- */
  var mainImg = root.querySelector('[data-n2-main-img]');
  var thumbs = root.querySelectorAll('[data-n2-thumb]');

  function setImage(src, thumbEl) {
    if (!mainImg || !src || mainImg.src === src) return;
    mainImg.classList.add('is-fading');
    setTimeout(function () {
      mainImg.src = src;
      mainImg.onload = function () { mainImg.classList.remove('is-fading'); };
      setTimeout(function () { mainImg.classList.remove('is-fading'); }, 320);
    }, 110);
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumbEl) thumbEl.classList.add('is-active');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setImage(thumb.dataset.n2Full, thumb);
    });
  });

  /* ---------- Variant picker ---------- */
  var swatches = root.querySelectorAll('[data-n2-cw]');
  var priceEl = root.querySelector('[data-n2-price]');
  var stockEl = root.querySelector('[data-n2-stock]');
  var atcBtns = root.querySelectorAll('[data-n2-atc]');
  var cwNameEl = root.querySelector('[data-n2-cw-name]');
  var idInput = root.querySelector('[data-n2-variant-id]');

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function updateStock(variant) {
    if (!stockEl) return;
    stockEl.classList.remove('in', 'low', 'out');
    var label = stockEl.querySelector('[data-n2-stock-text]');
    var qty = variant.inventory_quantity;
    var tracked = variant.inventory_management !== null && qty !== undefined && qty !== null;

    if (!variant.available) {
      stockEl.classList.add('out');
      label.textContent = 'Out of stock';
    } else if (tracked && qty > 0 && qty <= 4) {
      stockEl.classList.add('low');
      label.textContent = 'Only ' + qty + ' left';
    } else if (tracked && qty > 4) {
      stockEl.classList.add('in');
      label.textContent = 'In stock — ' + qty + ' available';
    } else {
      stockEl.classList.add('in');
      label.textContent = 'In stock';
    }
  }

  function filterThumbs(variantTitle) {
    var t = (variantTitle || '').toLowerCase().trim();
    var firstVisible = null;
    thumbs.forEach(function (th) {
      var g = (th.dataset.n2Group || '').trim();
      var show = g === 'shared' || g === t;
      th.hidden = !show;
      if (show && !firstVisible) firstVisible = th;
    });
    return firstVisible;
  }

  function selectVariant(variantId, swatchEl) {
    var variant = variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (!variant) return;

    swatches.forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-checked', 'false');
    });
    if (swatchEl) {
      swatchEl.classList.add('is-selected');
      swatchEl.setAttribute('aria-checked', 'true');
    }

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (cwNameEl) cwNameEl.textContent = variant.title;
    updateStock(variant);

    atcBtns.forEach(function (btn) {
      if (btn.dataset.n2Scroll === 'true') return;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? (btn.dataset.n2AtcLabel || 'Add to Cart') : 'Sold Out';
    });

    var firstVisible = filterThumbs(variant.title);

    if (variant.featured_image && variant.featured_image.src) {
      var match = null;
      var featBase = variant.featured_image.src.split('?')[0];
      thumbs.forEach(function (t) {
        if (!t.hidden && t.dataset.n2Full.split('?')[0].indexOf(featBase.replace(/^https?:/, '')) !== -1) match = t;
      });
      setImage(variant.featured_image.src, match || firstVisible);
    } else if (firstVisible) {
      setImage(firstVisible.dataset.n2Full, firstVisible);
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.classList.contains('is-soldout')) return;
      selectVariant(swatch.dataset.n2Cw, swatch);
    });
  });

  /* ---------- Add to cart ---------- */
  atcBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.dataset.n2Scroll === 'true') {
        var buybox = root.querySelector('.n2-pbuy');
        if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var variantId = idInput ? idInput.value : null;
      if (!variantId) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var drawer = document.querySelector('cart-drawer');
      var payload = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
      if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (response) {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('nor:cart:added'));
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 900);
          if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(response);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  });

  /* ---------- FAQ (one open at a time) ---------- */
  var faqItems = root.querySelectorAll('[data-n2-faq]');
  faqItems.forEach(function (item) {
    var q = item.querySelector('.n2-faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      faqItems.forEach(function (i) {
        i.classList.remove('is-open');
        var b = i.querySelector('.n2-faq-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Scroll reveal ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = root.querySelectorAll('.n2-reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Init from URL or first available ---------- */
  var params = new URLSearchParams(window.location.search);
  var initId = params.get('variant');
  var initVariant = null;
  if (initId) {
    initVariant = variants.filter(function (v) { return String(v.id) === initId; })[0];
  }
  if (!initVariant) {
    initVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
  }
  if (initVariant) {
    var initSwatch = null;
    swatches.forEach(function (s) {
      if (String(s.dataset.n2Cw) === String(initVariant.id)) initSwatch = s;
    });
    selectVariant(initVariant.id, initSwatch);
  }
})();
